import React, { useEffect } from 'react';
import { View, Text, TouchableOpacity, ActivityIndicator } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useNavigation } from '@react-navigation/native';
import styles, { colors } from '../../style/rulesEngine';
import Toast from '../../commons/Toast';
import useRuleManagement from '../../helpers/useRuleManagement';
import RulesList from './RulesList';
import EmptyState from './EmptyState';
import DeleteConfirmModal from './DeleteConfirmModal';

const RulesSection = () => {
  const navigation = useNavigation();
  const {
    rules, loading, error,
    deleteTarget, showToast, toastMessage, hideToast,
    handleDelete, handleToggle, handleReorder, handleDuplicate,
    handleFetchRules, setDeleteTarget,
  } = useRuleManagement();

  useEffect(() => {
    handleFetchRules();
  }, []);


  const navigateToCreate = () => {
    navigation.navigate('AutomationRules', { openCreate: true, returnToSettings: true });
  };

  const navigateToEdit = (rule) => {
    navigation.navigate('AutomationRules', { editRule: rule, returnToSettings: true });
  };

  const navigateToStarter = (starter) => {
    navigation.navigate('AutomationRules', { openCreate: true, starter, returnToSettings: true });
  };

  return (
    <>
      <LinearGradient
        colors={['rgba(17, 28, 41, 0.7)', 'rgba(37, 60, 87, 0.55)', 'rgba(92, 119, 143, 0.45)', 'rgba(92, 119, 143, 0.45)', 'rgba(37, 60, 87, 0.55)', 'rgba(17, 27, 39, 0.7)']}
        locations={[0.09, 0.19, 0.43, 0.58, 0.78, 0.92]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={{ borderRadius: 20, padding: 20, minHeight: 300, width: '100%', boxShadow: '0px 0px 10px 0px rgba(255, 255, 255, 0.2)' }}
      >
        <Text style={{ fontFamily: 'Poppins_700Bold', fontSize: 22, color: colors.text, marginBottom: 14 }}>
          Rules
        </Text>

        {loading && (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={colors.accent} />
            <Text style={styles.loadingText}>Loading rules...</Text>
          </View>
        )}

        {!loading && error && (
          <View style={styles.errorBanner}>
            <Text style={styles.errorBannerText}>
              {error?.message || 'Failed to load rules. Please try again.'}
            </Text>
            {!error?.forbidden && (
              <TouchableOpacity onPress={handleFetchRules}>
                <Text style={[styles.addButtonText, { marginLeft: 8 }]}>Retry</Text>
              </TouchableOpacity>
            )}
          </View>
        )}

        {!loading && !error && (
          <>
            {rules.length === 0 ? (
              <EmptyState
                onCreateFirst={navigateToCreate}
                onStarterSelected={navigateToStarter}
              />
            ) : (
              <RulesList
                rules={rules}
                onEdit={navigateToEdit}
                onToggle={handleToggle}
                onDelete={(rule) => setDeleteTarget(rule)}
                onDuplicate={handleDuplicate}
                onReorder={handleReorder}
                onCreateNew={navigateToCreate}
              />
            )}
          </>
        )}
      </LinearGradient>

      <Toast visible={showToast} message={toastMessage} onHide={hideToast} />

      <DeleteConfirmModal
        visible={deleteTarget !== null}
        ruleName={deleteTarget?.name}
        onConfirm={handleDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </>
  );
};

export default RulesSection;
